"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const utilities_1 = require("../../utilities");
const FoodCard_1 = __importDefault(require("../modules/FoodCard"));
const react_router_1 = require("react-router");
const client_socket_1 = require("../../client-socket");
const CalendarToggle_1 = require("../modules/CalendarToggle");
const FoodCalendar_1 = __importDefault(require("./FoodCalendar"));
const FoodPage = (props) => {
    const [foodEvents, setFoodEvents] = (0, react_1.useState)([]);
    const navigate = (0, react_router_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        document.title = "Food Events";
        const fetchFoodEvents = () => (0, utilities_1.get)("/api/foodevents", { scheduled: props.time === "scheduled" }).then(setFoodEvents);
        fetchFoodEvents();
        client_socket_1.socket.on("FoodEventsUpdate", fetchFoodEvents);
        return () => {
            client_socket_1.socket.off("FoodEventsUpdate", fetchFoodEvents);
        };
    }, [props.time]);
    const oppositeTime = props.time === "latest" ? "scheduled" : "latest";
    // https://mui.com/material-ui/react-card/#complex-interaction
    return (react_1.default.createElement(material_1.Container, { maxWidth: "md", sx: { alignContent: "center" } },
        react_1.default.createElement(material_1.Box, { display: "flex", alignItems: "center", sx: {
                pt: 2,
                pb: 2,
                gap: 3,
                justifyContent: {
                    xs: "space-evenly",
                    sm: "space-between",
                },
            } },
            react_1.default.createElement(material_1.Button, { variant: "contained", sx: { color: "#fff", fontWeight: 550 }, onClick: () => navigate("/food/new") }, "Submit a New Food"),
            react_1.default.createElement(material_1.Typography, { variant: "h5", align: "center", sx: {
                    pt: 1,
                    pb: 1,
                    pl: 3,
                    justifySelf: "center",
                    alignSelf: "center",
                    justifyItems: "center",
                    alignItems: "center",
                    display: {
                        xs: "none",
                        sm: "flex",
                    },
                } },
                props.time[0].toUpperCase(),
                props.time.substring(1),
                " Food"),
            react_1.default.createElement(material_1.Box, { sx: { display: "flex", my: 0 } },
                props.time === "scheduled" && (
                // <Box sx={{ display: "flex", my: 0 }}>
                react_1.default.createElement(CalendarToggle_1.MaterialUISwitch, { checked: props.view === "calendar", onChange: () => {
                        if (props.view === "grid") {
                            navigate("/food/calendar");
                        }
                        else {
                            navigate("/food/scheduled");
                        }
                    }, sx: { mr: 1 } })
                // </Box>
                ),
                react_1.default.createElement(material_1.Button, { variant: "contained", sx: { color: "#fff", fontWeight: 550 }, onClick: () => navigate(`/food/${oppositeTime}`) },
                    "See ",
                    oppositeTime,
                    " foods"))),
        props.view === "grid" && (react_1.default.createElement(material_1.Grid, { container: true, spacing: 4 }, foodEvents.map((foodEvent) => (react_1.default.createElement(material_1.Grid, { item: true, key: foodEvent._id, xs: 12, sm: 12, md: 6 },
            react_1.default.createElement(FoodCard_1.default, Object.assign({}, foodEvent, { key: foodEvent._id }))))))),
        props.view === "calendar" && react_1.default.createElement(FoodCalendar_1.default, { foodEvents: foodEvents })));
};
exports.default = FoodPage;
